import ChipsField, { ChipsFieldProps } from './ChipsField';

export type { ChipsFieldProps };
export default ChipsField;
